import { Client } from './Client';
import Broadcast from './Broadcast';

const client = new Client();
const broadcast = new Broadcast(client);

export { client as Client, broadcast as Broadcast };
